/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_Five_FramesInputs */

const en_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back five frames in the video`)
};

const fr_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reculer de cinq images dans la video`)
};

const de_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spule im Video fünf Frames zurück.`)
};

const it_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna indietro di cinque fotogrammi nel video`)
};

const ru_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернитесь на пять кадров назад в видео.`)
};

const es_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retroceda cinco fotogramas en el vídeo`)
};

const zh_cn2_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频倒回前五帧。`)
};

const ja_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオを5フレーム前に戻す`)
};

const hi_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में पांच फ्रेम पीछे जाएं`)
};

const pt_pt2_shortcut_keys_desc_reverse_five_frames = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volte cinco frames no vídeo.`)
};

/**
* | output |
* | --- |
* | "Go back five frames in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_Five_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_five_frames = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_Five_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_Five_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_reverse_five_frames(inputs)
	if (locale === "de") return de_shortcut_keys_desc_reverse_five_frames(inputs)
	if (locale === "it") return it_shortcut_keys_desc_reverse_five_frames(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_reverse_five_frames(inputs)
	if (locale === "es") return es_shortcut_keys_desc_reverse_five_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_reverse_five_frames(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_reverse_five_frames(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_reverse_five_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_reverse_five_frames(inputs)
	return en_shortcut_keys_desc_reverse_five_frames(inputs)
});